import axios from 'axios';
import FileUtils from '../utils/file.utils';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

function getHeaders() {
  const token = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

// El middleware central responde { status: 'error', message, code }; se acepta también
// el sobre { error: { code, message } } del CLAUDE.md del backend.
function toError(error) {
  const body = error.response?.data || {};
  return {
    status: 'error',
    message: body.error?.message ?? body.message ?? error.message,
    code: body.error?.code ?? body.code,
    httpCode: error.response?.status
  };
}

// El ícono nuevo viaja como iconBase64 (sin prefijo data:); sin archivo nuevo se conserva
// iconUrl tal cual (URL actual o null para quitarlo). El `File` nunca se envía.
async function toChannelPayload({ iconFile, ...channel }) {
  if (!iconFile) return channel;
  return { ...channel, iconBase64: await FileUtils.getBase64(iconFile), iconFileName: iconFile.name };
}

export async function buildProfilePayload({ channels, ...profile }) {
  return { ...profile, channels: await Promise.all(channels.map(toChannelPayload)) };
}

// Perfiles de redirección de reembolsos (125-service-refund-redirect).
// El backend responde { data } (sin status: 'ok'); aquí se normaliza al contrato del
// resto de src/services/: { status: 'ok', data } en éxito, { status: 'error', message, code, httpCode } en error.
export default class RefundRedirectProfilesService {
  static async getAll() {
    try {
      const response = await axios.get(`${ADMIN_URL}/refund-redirect-profiles`, { headers: getHeaders() });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return toError(error);
    }
  }

  // profile: { companyId, title, channels: [{ label, type, value, iconUrl, iconFile }] }, en el orden de los canales.
  // Se envía { companyId, title, channels: [{ label, type, value, iconUrl, iconBase64?, iconFileName? }] }.
  static async create(profile) {
    try {
      const payload = await buildProfilePayload(profile);
      const response = await axios.post(`${ADMIN_URL}/refund-redirect-profiles`, payload, {
        headers: getHeaders()
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return toError(error);
    }
  }

  // Reemplazo completo: el formulario siempre envía el perfil entero.
  static async update(profileId, profile) {
    try {
      const payload = await buildProfilePayload(profile);
      const response = await axios.put(`${ADMIN_URL}/refund-redirect-profiles/${profileId}`, payload, {
        headers: getHeaders()
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return toError(error);
    }
  }

  // 409 REFUND_REDIRECT_PROFILE_IN_USE si algún plan-servicio lo usa; el mensaje nombra los planes.
  static async remove(profileId) {
    try {
      await axios.delete(`${ADMIN_URL}/refund-redirect-profiles/${profileId}`, { headers: getHeaders() });
      return { status: 'ok' };
    } catch (error) {
      return toError(error);
    }
  }
}
